import { render, staticRenderFns } from "./waitingForDocsSearch.vue?vue&type=template&id=6d303449"
import script from "./waitingForDocsSearch.vue?vue&type=script&lang=js"
export * from "./waitingForDocsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports